// src/pages/auth/EmailConfirmedPage.tsx
import React, { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { supabase } from '../../lib/supabaseClient'

const EmailConfirmedPage: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { refreshProfile, user } = useAuth()

  // Si on vient avec un "redirect" dans l’URL, sinon on renvoie vers /order/start
  const params = new URLSearchParams(location.search)
  const redirectTo = params.get('redirectTo') || '/order/start'

  useEffect(() => {
    const sync = async () => {
      await refreshProfile()

      // Vérifier si le profil est complet (nom complet + téléphone)
      let finalRedirect = redirectTo
      if (user?.id) {
        const { data: profileData } = await supabase
          .from('profiles')
          .select('full_name, phone')
          .eq('id', user.id)
          .single()

        const isIncomplete = !profileData?.full_name?.trim() || !profileData?.phone?.trim()
        if (isIncomplete) {
          finalRedirect = `/account/personal-info?redirect=${encodeURIComponent(redirectTo)}`
        }
      }

      // Laisser l'utilisateur voir le message 1–2 secondes avant de rediriger
      setTimeout(() => {
        navigate(finalRedirect, { replace: true })
      }, 1500)
    }

    void sync()
  }, [refreshProfile, navigate, redirectTo, user])

  return (
    <div
      style={{
        maxWidth: '480px',
        margin: '2rem auto',
        background: '#0f172a',
        color: '#f1f5f9',
        borderRadius: '1rem',
        padding: '2rem',
        boxShadow: '0 0 20px rgba(0,0,0,0.4)',
        textAlign: 'center',
      }}
    >
      <h1 style={{ fontSize: '1.4rem', marginBottom: '1rem', color: '#22c55e' }}>
        🎉 Compte activé
      </h1>
      <p style={{ marginBottom: '0.5rem' }}>
        Ton adresse email a été confirmée et tu es maintenant connecté.
      </p>
      <p style={{ fontSize: '.9rem', color: '#9ca3af' }}>
        Tu vas être redirigé automatiquement vers ton espace.
      </p>
      <button
        className="btn btn-primary"
        style={{ marginTop: '1rem' }}
        onClick={() => navigate(redirectTo, { replace: true })}
      >
        Continuer
      </button>
    </div>
  )
}

export default EmailConfirmedPage
